export class IntId {
	private value_: number;

	constructor(v: number = 0) {
		this.value_ = v;
	}

	valid(sign: any) {
		return sign === this.value_;
	}

	current() {
		return this.value_;
	}

	next() {
		this.value_++;
		return this.value_;
	}
}
